/**
 * PatchView — renders a single file's unified-diff patch with +/-/@@ coloring.
 *
 * Ported from the AgentFleet Console's FleetDetail.tsx PatchView (the same
 * review surface, now inside Mission Control) so an operator never has to
 * leave MC to read a proposed change's diff.
 */
export function PatchView({ patch }: { patch: string }) {
  if (!patch) {
    return <p className="text-xs text-gray-400 italic px-3 py-2">No textual diff (binary or too large).</p>
  }
  return (
    <pre className="text-xs font-mono overflow-x-auto leading-relaxed">
      {patch.split('\n').map((line, i) => {
        let cls = 'text-gray-600'
        if (line.startsWith('+') && !line.startsWith('+++')) cls = 'bg-green-50 text-green-800'
        else if (line.startsWith('-') && !line.startsWith('---')) cls = 'bg-red-50 text-red-800'
        else if (line.startsWith('@@')) cls = 'text-indigo-600 bg-indigo-50'
        return (
          <div key={i} className={cls}>
            {line || ' '}
          </div>
        )
      })}
    </pre>
  )
}
